import React from "react";
import { notify } from "@/shared/utils/notify";
import { rulesApplyFiftyPercentDiscount } from "../../../shared/services";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { SelectedDaysType } from "../ui";
import { IRulesSushiLunch } from "../../../redux/@types";

export const useEditRulesSushiLunch = ({
  setOpenModalEditRule,
  comboRuleById,
  days,
  selectedCategoryIds,
}: {
  setOpenModalEditRule: (val: boolean) => void;
  comboRuleById: IRulesSushiLunch | undefined;
  days: SelectedDaysType;
  selectedCategoryIds: string[];
}) => {
  const [loading, setLoading] = React.useState<boolean>(false);

  const {
    control,
    handleSubmit: onSubmit,
    reset,
  } = useForm<any>({
    resolver: yupResolver(
      yup.object({
        name: yup.string().required("Campo requerido"),
      })
    ),
  });

  const editComboRule = onSubmit(async (data: IRulesSushiLunch) => {
    if (loading || !comboRuleById) return;

    setLoading(true);
    try {
      await rulesApplyFiftyPercentDiscount.patch(comboRuleById.id, {
        name: data.name,
        status: data.status,
        monday: days.monday,
        tuesday: days.tuesday,
        wednesday: days.wednesday,
        thursday: days.thursday,
        friday: days.friday,
        saturday: days.saturday,
        sunday: days.sunday,
        category_ids: selectedCategoryIds.map((id) => Number(id)),
        apply_to_category_id: selectedCategoryIds[0]
          ? Number(selectedCategoryIds[0])
          : data.apply_to_category_id
            ? Number(data.apply_to_category_id)
            : undefined,
      });
      setOpenModalEditRule(false);
      notify.success("Regla editada exitosamente");
    } catch (err: any) {
      notify.error(err.message);
    } finally {
      setLoading(false);
    }
  });

  React.useEffect(() => {
    if (comboRuleById) {
      reset({
        name: comboRuleById.name,
        status: comboRuleById.status,
        monday: comboRuleById.monday,
        tuesday: comboRuleById.tuesday,
        wednesday: comboRuleById.wednesday,
        thursday: comboRuleById.thursday,
        friday: comboRuleById.friday,
        saturday: comboRuleById.saturday,
      });
    }
  }, [comboRuleById, reset]);

  return {
    loading,
    control,
    editComboRule,
  };
};
